import React from 'react';
import "../../styles/global-hero.css";

const Hero = () => {
    return (
        <div className="global-hero">
            <div className="container text-center">
            <h1>Programmes Offered</h1>
            <p>Home &gt; Programmes Offered &gt; Biochemistry</p>
            </div>
        </div>
    )
}

export default Hero;